import styled from 'styled-components';
import { Button } from 'components';

export const OpSectionWrapper = styled.div`
  position: relative;
  margin: 40px 0 20px 0;
`;

export const OpSectionTitle = styled.h3`
  cursor: pointer;
  > span {
    color: ${props => props.theme.color.wfGrey500};
  }
`;

export const ButtonExpand = styled(Button)`
  position: absolute;
  top: -2px;
  right: 0;
`;

export const Card = styled.div`
  width: 100%;
  margin: 20px auto;
  position: relative;
`;

export const Title = styled.h4`
  margin: 0 0 ${props => props.theme.spacing.small} 0;
  font-weight: 600;
  font-size: 0.925em;
`;

export const OpName = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  color: ${props => props.color};
  font-size: 0.875em;
  font-weight: 600;
`;
